import React, { Fragment, useCallback } from "react";
import makeStyles from "@mui/styles/makeStyles";
import clsx from "clsx";
import { any, isEmpty, propEq } from "ramda";

import Button from "@mui/material/Button";
import { notBlank, notEmpty } from "../../../util/ext";
import Grid from "@mui/material/Grid";
import Skeleton from "@mui/material/Skeleton";

const useStyles = makeStyles(theme => ({
  root: {
    flexGrow: 1,
    overflowX: "auto",
    overflowY: "hidden",
  },

  typeFacet: {
    color: theme.palette.primary.darker,
    textTransform: "capitalize",
    fontSize: "1.4rem",
  },

  selected: {
    color: theme.palette.primary.main,
    fontWeight: "bolder",
  },
}));
const ContentTypeFilters = props => {
  const {
    contentTypes,
    contentTypeTerms,
    onContentTypeSelected,
    onClear,
    loading,
  } = props;

  const classes = useStyles();

  const handleContentTypeSelected = useCallback(
    term => {
      onContentTypeSelected(term);
    },
    [onContentTypeSelected],
  );

  const handleClearContentTypes = useCallback(() => {
    onClear();
  }, [onClear]);

  return (
    <Grid
      className={classes.root}
      container
      item
      wrap="nowrap"
      alignItems="center"
      xs
    >
      {loading ? (
        <Skeleton width={"100%"} height={50} />
      ) : (
        notBlank(contentTypes) && (
          <Fragment>
            <Button
              className={clsx(classes.typeFacet, {
                [classes.selected]: isEmpty(contentTypeTerms),
              })}
              variant="text"
              onClick={handleClearContentTypes}
            >
              All
            </Button>
            {notEmpty(contentTypes) &&
              contentTypes.terms.map(term => (
                <Button
                  key={"content-type-facet-term-" + term.label}
                  className={clsx(classes.typeFacet, {
                    [classes.selected]: any(
                      propEq("label", term.label),
                      contentTypeTerms,
                    ),
                  })}
                  variant="text"
                  onClick={() => handleContentTypeSelected(term)}
                >
                  {term.count
                    ? `${term.label} (${term.count.toLocaleString()})`
                    : term.label}
                </Button>
              ))}
          </Fragment>
        )
      )}
    </Grid>
  );
};

export default ContentTypeFilters;
